// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/**\n* Colors\n*/\n.ant-timeline-item-last {\n  position: relative;\n  padding-bottom: 0; }\n  .ant-timeline-item-last:before {\n    content: ' ';\n    width: 2px;\n    min-height: 10px;\n    border-right: 2px solid #f0f0f0;\n    position: absolute;\n    left: 4px;\n    bottom: 16px;\n    top: 0; }\n", ""]);
// Exports
module.exports = exports;
